import { Media, MediaBassUArticle, MediaPrismicArticle, TechniqueFull } from '@omniafishing/core';
import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import bgPattern from '../../assets/topo-blue-pattern.png';
import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import { OmniaBreadcrumb } from '../../components/omnia_breadcrumb/omnia_breadcrumb';
import { RoutePaths } from '../../routes';
import styles from './technique_detail.less';
import { TechniqueMedia } from './technique_media';
import { TechniqueProductsGridContainer } from './technique_products_grid/technique_products_grid_container';

export interface TechniqueDetailProps {
  technique: TechniqueFull;
  media: Media[];
}

export const TechniqueDetail = (props: TechniqueDetailProps) => {
  const { technique, media } = props;

  const { page_heading, page_subheading, display_name, description, banner_image } = technique;
  const youtubeMedia = media.filter(
    (content) =>
      (content.media_type === 'BassUArticle' || content.media_type === 'PrismicArticle') &&
      content.media_item.youtube_url
  ) as (MediaPrismicArticle | MediaBassUArticle)[];

  return (
    <section>
      <header
        className={styles.header}
        style={{
          backgroundImage: `url(${banner_image || bgPattern})`,
          backgroundSize: !banner_image && '600px',
        }}
      >
        <div className={styles.headerOverlay}>
          <ContentWrapper>
            <h1 className={styles.h1}>{page_heading || `${_.startCase(display_name)} Fishing`}</h1>
            {page_subheading && (
              <p className={classNames(styles.subhead, 'mb-4')}>{page_subheading}</p>
            )}
            {description && (
              <div dangerouslySetInnerHTML={{ __html: description }} className="mb-4" />
            )}
          </ContentWrapper>
        </div>
      </header>

      <ContentWrapper>
        <OmniaBreadcrumb
          items={[
            {
              name: 'Techniques',
              url: RoutePaths.TECHNIQUES,
            },
            {
              name: display_name,
              url: null,
            },
          ]}
          className={styles.breadcrumb}
        />
      </ContentWrapper>

      {youtubeMedia.length > 0 && (
        <section className="mb-6">
          <ContentWrapper>
            <h2 className="text-xl mb-3">Featured Videos for {display_name}</h2>
            <TechniqueMedia youtubeMedia={youtubeMedia} />
          </ContentWrapper>
        </section>
      )}

      <section className={styles.products}>
        <TechniqueProductsGridContainer technique={technique} key={technique.name} />
      </section>
    </section>
  );
};
